import input from '@/components/input'

/**
 * @module
 * @name InputText
 * @extends Input
 */
export default {
  name: 'InputTextNumbers',
  extends: input,

  /**
   * @property {String} icon VueSVGicon
   * @property {String} placeholder Placeholder to show while input is empty.
   * @property {String} type Text input could also be of type number, password.
   * @property {Boolean} removeIcon If true, shows X to delete input content.
   */
  props: {
    icon: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: v => ['text', 'password'].indexOf(v) !== -1,
      default: 'text'
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputmode: {
      type: String,
      required: false
    }
  },

  /**
   * @property {Boolean} showRemoveIcon  Returns if removeIcon should be showed.
   */
  computed: {
    showRemoveIcon: function () {
      return this.removeIcon && this.value && this.value.length > 0
    }
  },
  
}
